<template>
  <div>
    
    <b-modal v-model="modalShow" ref="modalSensorEdit"
            size="xl" 
            :title="modalTitle" 
            @hide="resetInfoModal"
            hideFooter>
        <sensor-add-form ref="sensorForm" 
                        @onClickSave="processSensorSaved()" 
                        @onClickExit="hideModal" />
    </b-modal>
  </div>
</template>

<script>
import SensorAdd from '@/components/sensors/SensorsAdd';

export default {
  name: "edit-sensor-modal",
  components: {
    'sensor-add-form': SensorAdd
  },
  data() {
    return {
      modalShow: false, 
      modalTitle: "Nodo"
    };
  },
  methods: {

    processSensorSaved(){
      // Hide modal
      this.modalShow = false;

      this.$emit('onClickSave');
    },

    resetInfoModal() {
      this.$refs.sensorForm.resetValues();
    },
    
    showModal(id){

      if(id){
        this.modalTitle = 'Sensor - Modificar';
      }
      else{
        this.modalTitle = 'Sensor - Agregar nuevo';
      }

      this.modalShow = true;
      this.$refs.modalSensorEdit.show();

      if(id){
        this.$nextTick(() => {
          // DOM updated
          //this.$refs.sensorForm.getSensor(id);
        })
      }
    },

    hideModal(){
      this.modalShow = false;
    }
  }
};
</script>

<style scoped>
</style>
